import React from "react";
import "./Footer.css";
import logo from "../../../images/logo.png";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" aria-label="Site Footer">
      <div className="container">
        <div className="footer-top">
          <div className="row g-5">
            {/* Brand Column */}
            <div className="col-lg-4 col-md-6 footer-brand">
              <img src={logo} alt="Yitalife - Yita Medical Services logo" />
              <div className="footer-brand-name">Yitalife</div>
              <p className="footer-brand-tagline">
                <em>A service of Yita Medical Services (YMS)</em>
              </p>
              <p className="footer-brand-desc">
                Providing equitable access to affordable, high-quality
                doctor-led healthcare - at your home, workplace, and remote
                community across Uganda and Africa.
              </p>
              <p className="footer-reg">
                Reg No. 80020035497111 · Kampala, Uganda
              </p>
              <div className="footer-social" style={{ marginTop: "16px" }}>
                <a
                  href="https://x.com/yitalife"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Yitalife on Twitter"
                >
                  <ion-icon name="logo-twitter"></ion-icon>
                </a>
                <a
                  href="https://www.facebook.com/yitalife.yms?mibextid=LQQJ4d"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Yitalife on Facebook"
                >
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
                <a href="mailto:info@yitalife.com" aria-label="Email Yitalife">
                  <ion-icon name="mail-outline"></ion-icon>
                </a>
                <a href="tel:+256777114327" aria-label="Call Yitalife">
                  <ion-icon name="call-outline"></ion-icon>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 col-sm-6">
              <h6 className="footer-col-heading">Quick Links</h6>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/AboutUs">About Yitalife</Link>
                </li>
                <li>
                  <Link to="/Services">Our Services</Link>
                </li>
                <li>
                  <Link to="/Leadership">Leadership</Link>
                </li>
                <li>
                  <Link to="/Activity">Activities</Link>
                </li>
                <li>
                  <Link to="/Gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/Contact">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h6 className="footer-col-heading">Key Services</h6>
              <ul className="footer-links">
                <li>
                  <Link to="/services/doctor-home-visit">
                    Doctor Home Visits
                  </Link>
                </li>
                <li>
                  <Link to="/services/hospital-at-home">
                    Hospital at Home Care
                  </Link>
                </li>
                <li>
                  <Link to="/services/antenatal-maternal-care">
                    Antenatal &amp; Maternal Care
                  </Link>
                </li>
                <li>
                  <Link to="/services/corporate-health-assessment">
                    Corporate Health Assessment
                  </Link>
                </li>
                <li>
                  <Link to="/services/telemedicine">Telemedicine</Link>
                </li>
                <li>
                  <Link to="/services/mental-health">
                    Mental Health Services
                  </Link>
                </li>
                <li>
                  <Link to="/Appointment">Book Appointment</Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6">
              <h6 className="footer-col-heading">Contact Us</h6>

              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <ion-icon name="location-outline"></ion-icon>
                </div>
                <div className="footer-contact-text">
                  Phlona Medical Chambers
                  <br />
                  Makerere Kavule, Kampala, Uganda
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <ion-icon name="call-outline"></ion-icon>
                </div>
                <div className="footer-contact-text">
                  <a href="tel:+256777114327">+256 777 114 327</a>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <ion-icon name="mail-outline"></ion-icon>
                </div>
                <div className="footer-contact-text">
                  <a href="mailto:info@yitalife.com">info@yitalife.com</a>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <ion-icon name="alarm-outline"></ion-icon>
                </div>
                <div className="footer-contact-text">
                  Mon - Fri: 8:30 am - 11:30 pm
                  <br />
                  Sat - Sun: 10:00 am - 11:30 pm
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container">
          <p className="footer-copyright">
            &copy; {year} <span>Yita Medical Services (YMS)</span> All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
